import { clearInputField, getQueryStringParameter } from '../../../helpers.js'

$(document).ready(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'performed_operation') {
    return;
  }

  const $performedOperationsOnInvestments = $('#performedOperationsOnInvestments input[type=radio]', $form);
  const $hasPerformedOperation            = $('#hasPerformedOperation', $form);

  $performedOperationsOnInvestments.each((_, inputElement) => {
    if(inputElement.checked && inputElement.value === 'true') {
      $hasPerformedOperation.removeClass('d-none');
    }
  });

  $performedOperationsOnInvestments.on('click', (inputElement) => {
    if(inputElement.target.value === 'true') {
      $hasPerformedOperation.removeClass('d-none');
    } else {
      clearInputField(document.getElementById('users_profile_natural_performed_operations_on_investments_details'));
      $form.submit();
    }
  });
})
